export default "/7ee56fc642439642e071ad6692a1a8b95a874bf4/b3dc542ec1b5794376b3d1da54a4e35b.svg";